(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TaskTypeDetailController', TaskTypeDetailController);

    TaskTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TaskType', 'User'];

    function TaskTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TaskType, User) {
        var vm = this;

        vm.taskType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:taskTypeUpdate', function(event, result) {
            vm.taskType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
